<template>
  <div>
    <div class="block">
      <el-form :inline="true">
        <el-form-item>
          <el-autocomplete style="margin-right:5px;" placeholder="请输入交易对" v-model="pair" :fetch-suggestions="querySearchAsync" @change="findOne"></el-autocomplete>
          <el-button type="primary" @click="findOne()">搜索</el-button>
          <el-button type="primary" @click="exportExcelMarket()">导出</el-button>
          <el-button type="success" @click="refreshConfigurations">刷新</el-button>
          <el-button type="success" @click="submit">修改</el-button>
        </el-form-item>
      </el-form>
      <el-form :model="configuration" label-width="200px" ref="form" :rules="rules">

        <el-form-item label="类型" prop="interval">
          <el-select v-model="configuration.machineType" placeholder="请选择类型">
            <el-option v-for="item in machineTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="交易所" prop="srcExchanges">
          <el-select v-model="configuration.srcExchanges" placeholder="请选择交易所">
            <el-option v-for="item in exchangeSrcEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="TOKEN ID或目标币或指数价"
                      v-if="configuration.srcExchanges==='UNISWAP'
                          || configuration.srcExchanges==='MDEX'
                          || configuration.srcExchanges==='FIXED_USDT'
                          || configuration.srcExchanges==='CUSTOM_PRICE'
                          || configuration.srcExchanges === 'PANCAKE'
                          || configuration.srcExchanges === 'BAKERY'
                          || configuration.srcExchanges === 'PANGOLIN'
                          || configuration.srcExchanges === 'SPOOKYSWAP'
                          || configuration.srcExchanges === 'SHIBASWAP'
                          || configuration.srcExchanges === 'JOE'
                          || configuration.srcExchanges === 'SUSHI'
                          || configuration.srcExchanges === 'RAYDIUM'
                          || configuration.srcExchanges === 'QUICKSWAP'">
          <el-form :inline="true">
            <el-form-item>
              <el-input type="number" v-model="configuration.otherConfig" v-if="configuration.srcExchanges==='CUSTOM_PRICE'" STYLE="width: 300px;" :maxlength=maxLengthNum></el-input>
              <el-input v-model="configuration.otherConfig" STYLE="width: 500px;" v-else></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model=maxLengthNum maxlength="3" STYLE="width: 120px;" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" v-if="configuration.srcExchanges==='CUSTOM_PRICE'">
                <template slot="prepend">最大输入长度</template>
              </el-input>
            </el-form-item>
          </el-form>
        </el-form-item>

        <el-form-item  label="行情同步开关">
          <el-radio-group v-model="configuration.enabledFlag">
            <el-radio class="radio" label="1">是</el-radio>
            <el-radio class="radio" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  label="成交刷量开关">
          <el-radio-group v-model="configuration.dealFlag">
            <el-radio class="radio" label="1">是</el-radio>
            <el-radio class="radio" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="价差比例阈值" prop="thresholdStopProcessDepth">
          <el-input-number v-model="configuration.thresholdStopProcessDepth"></el-input-number>
        </el-form-item>
        <el-form-item label="成交量缩放" prop="dealAmtPercentage">
          <el-input-number v-model="configuration.dealAmtPercentage"></el-input-number>
        </el-form-item>

        <el-form-item label="买baseAmt" prop="bidBaseAmt" >
          <el-tooltip placement="bottom-start" slot="label">
            <div slot="content">
              <h3>买方向金额 = (买baseAmt) * <b style="color: red">P</b> / 当前币对usdt价</h3>
              <div :style="configuration.level && configuration.level != 1 ? {opacity: 0.3}: {}">
                <h4>等级一的币对：</h4>
                <ul>
                  <li>2/3 的概率：P = 5-10 间随机值</li>
                  <li>2/9 的概率：P = 3-5 间随机值</li>
                  <li>1/9 的概率：P = 1.2-3 间随机值</li>
                </ul>
              </div>
              <div :style="configuration.level && configuration.level != 1 ? {opacity: 0.3}: {}">
                <h4>其他币对：</h4>
                <ul :style="configuration.level && configuration.level == 1 ? {opacity: 0.3}: {}">
                  <li>2/3 的概率：P = 3-5 间随机值</li>
                  <li>1/3 的概率：P = 1.2-3 间随机值</li>
                </ul>
              </div>
            </div>
            <span>
                    买baseAmt<i class="el-icon-question"/>
                  </span>
          </el-tooltip>
          <el-input-number v-model="configuration.bidBaseAmt"></el-input-number>
        </el-form-item>
        <el-form-item label="卖baseAmt" prop="askBaseAmt">
          <el-tooltip placement="bottom-start" slot="label">
            <div slot="content">
              <h3>
                卖方向金额 = (卖baseAmt) * <b style="color: red">P</b> / 当前币对usdt价
              </h3>
              <div :style="configuration.level && configuration.level != 1 ? {opacity: 0.3}: {}">
                <h4>等级一的币对：</h4>
                <ul>
                  <li>2/3的概率：P = 5-10 间随机值</li>
                  <li>2/9 的概率：P = 3-5 间随机值</li>
                  <li>1/9 的概率：P = 1.2-3 间随机值</li>
                </ul>
              </div>
              <div :style="configuration.level && configuration.level != 1 ? {opacity: 0.3}: {}">
                <h4>其他币对：</h4>
                <ul :style="configuration.level && configuration.level == 1 ? {opacity: 0.3}: {}">
                  <li>2/3的概率：P = 3-5 间随机值</li>
                  <li>1/3的概率：P = 1.2-3 间随机值</li>
                </ul>
              </div>
            </div>
            <span>卖baseAmt<i class="el-icon-question"/></span>
          </el-tooltip>
          <el-input-number v-model="configuration.askBaseAmt"></el-input-number>
        </el-form-item>

        <el-form-item label="买密度" prop="bidPriceDensity">
          <el-input-number v-model="configuration.bidPriceDensity"></el-input-number>
        </el-form-item>
        <el-form-item label="卖密度" prop="askPriceDensity">
          <el-input-number v-model="configuration.askPriceDensity"></el-input-number>
        </el-form-item>
        <el-form-item label="买1撤回" prop="bidFirstPlaceDiscounted">
          <el-input-number v-model="configuration.bidFirstPlaceDiscounted"></el-input-number>
        </el-form-item>
        <el-form-item label="卖1撤回" prop="askFirstPlaceDiscounted">
          <el-input-number v-model="configuration.askFirstPlaceDiscounted"></el-input-number>
        </el-form-item>
        <el-form-item label="买方向委托量缩小档位" prop="bidPositionReduce">
          <el-input-number v-model="configuration.bidPositionReduce"></el-input-number>
        </el-form-item>
        <el-form-item label="卖方向委托量缩小档位" prop="askPositionReduce">
          <el-input-number v-model="configuration.askPositionReduce"></el-input-number>
        </el-form-item>
        <el-form-item label="买方向档位固定金额" prop="bidPositionAmount">
          <el-input-number v-model="configuration.bidPositionAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="卖方向档位固定金额" prop="askPositionAmount">
          <el-input-number v-model="configuration.askPositionAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="买吃单价差" prop="bidTradePriceRate">
          <el-input-number v-model="configuration.bidTradePriceRate"></el-input-number>
        </el-form-item>
        <el-form-item label="卖吃单价差" prop="askTradePriceRate">
          <el-input-number v-model="configuration.askTradePriceRate"></el-input-number>
        </el-form-item>
        <el-form-item label="时间间隔（秒）" prop="interval">
          <el-input-number v-model="configuration.interval"></el-input-number>
        </el-form-item>
        <el-form-item label="otherConfig" prop="otherConfig">
          <el-input v-model="configuration.otherConfig"></el-input>
        </el-form-item>

        <el-form-item label="币对等级">
          <el-radio-group v-model="configuration.level">
            <el-radio class="radio" label="1">1</el-radio>
            <el-radio class="radio" label="2">2</el-radio>
            <el-radio class="radio" label="3">3</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  label="指数价手动偏移开关">
          <el-radio-group v-model="configuration.priceManualDeviateFlag">
            <el-radio class="radio" label="1">是</el-radio>
            <el-radio class="radio" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="指数价手动偏移比例" v-if="configuration.priceManualDeviateFlag === '1'">
              <el-input-number v-model="configuration.priceManualDeviateRatio"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item  label="动态买卖回撤开关">
          <el-radio-group v-model="configuration.priceAutoDeviateFlag">
            <el-radio class="radio" label="1">是</el-radio>
            <el-radio class="radio" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row>
          <el-col :span="6">
            <el-form-item label="动态买卖回撤偏移量" v-if="configuration.priceAutoDeviateFlag === '1'">
              <el-input-number v-model="configuration.priceAutoDeviateAmt"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="动态买卖回撤偏移比例" v-if="configuration.priceAutoDeviateFlag === '1'">
              <el-input-number v-model="configuration.priceAutoDeviateRatio"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="动态买卖回撤最大比例" v-if="configuration.priceAutoDeviateFlag === '1'">
              <el-input-number v-model="configuration.priceAutoDeviateMaxRate"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item  label="自定义盘口配置开关">
          <el-radio-group v-model="configuration.customPositionFlag">
            <el-radio class="radio" label="1">是</el-radio>
            <el-radio class="radio" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘低档位区间" prop="bidLowPlaceRegion" v-if="configuration.customPositionFlag === '1'">
              <el-tooltip placement="bottom-start" slot="label">
                <div slot="content">
                  <h3>买盘低档位区间</h3>
                  <div>
                    <h4>1,5 表示 1-5 档，包含1和5</h4>
                  </div>
                </div>
                <span>买盘低档位区间<i class="el-icon-question"/></span>
              </el-tooltip>

              <el-input-number v-model="configuration.bidLowPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidLowPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘低档位区间" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askLowPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askLowPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘低档位大部分概率" v-if="configuration.customPositionFlag === '1'">
              <el-tooltip placement="bottom-start" slot="label">
                <div slot="content">
                  <h3>买盘低档位大部分概率</h3>
                  <div>
                    <h4>设置为 1/5，则配置为 1,5</h4>
                  </div>
                </div>
                <span>买盘低档位大部分概率<i class="el-icon-question"/></span>
              </el-tooltip>
              <el-input-number v-model="configuration.bidLowMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidLowMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘低档位大部分概率" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askLowMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askLowMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘低档位大部分倍数" v-if="configuration.customPositionFlag === '1'">
              <el-tooltip placement="bottom-start" slot="label">
                <div slot="content">
                  <h3>买盘低档位大部分倍数</h3>
                  <div>
                    <h4>基于买盘低档位大部分概率配置的 1/5 概率的base_amt倍数； 5,10， 表示5-10之间的随机倍数</h4>
                  </div>
                </div>
                <span>买盘低档位大部分倍数<i class="el-icon-question"/></span>
              </el-tooltip>
              <el-input-number v-model="configuration.bidLowMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidLowMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘低档位大部分倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askLowMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askLowMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘低档位其余倍数" v-if="configuration.customPositionFlag === '1'">
              <el-tooltip placement="bottom-start" slot="label">
                <div slot="content">
                  <h3>买盘低档位其余倍数</h3>
                  <div>
                    <h4>概率为（1-1/5=4/5）的base_amt倍数，3,5 表示 3-5 之间的随机倍数</h4>
                  </div>
                </div>
                <span>买盘低档位其余倍数<i class="el-icon-question"/></span>
              </el-tooltip>
              <el-input-number v-model="configuration.bidLowOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidLowOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘低档位其余倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askLowOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askLowOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="configuration.customPositionFlag === '1'">
          <el-col :span="24"><div class="grid-content bg-purple-light"></div></el-col>
        </el-row>
        <br v-if="configuration.customPositionFlag === '1'">
        <br v-if="configuration.customPositionFlag === '1'">

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘中档位区间" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.bidMediumPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidMediumPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘中档位区间" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askMediumPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askMediumPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘中档位大部分概率" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.bidMediumMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidMediumMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘中档位大部分概率" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askMediumMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askMediumMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘中档位大部分倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.bidMediumMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidMediumMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘中档位大部分倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askMediumMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askMediumMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘中档位其余倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.bidMediumOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidMediumOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘中档位其余倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askMediumOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askMediumOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="configuration.customPositionFlag === '1'">
          <el-col :span="24"><div class="grid-content bg-purple-light"></div></el-col>
        </el-row>
        <br v-if="configuration.customPositionFlag === '1'">
        <br v-if="configuration.customPositionFlag === '1'">

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘高档位区间" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.bidHighPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidHighPlaceRegionUpper" required="required"  clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘高档位区间" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askHighPlaceRegionLower" required="required" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askHighPlaceRegionUpper" required="required" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘高档位大部分概率" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.bidHighMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidHighMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘高档位大部分概率" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askHighMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askHighMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘高档位大部分倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.bidHighMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidHighMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘高档位大部分倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askHighMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askHighMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘高档位其余倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.bidHighOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.bidHighOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘高档位其余倍数" v-if="configuration.customPositionFlag === '1'">
              <el-input-number v-model="configuration.askHighOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input-number>
              <span> - </span>
              <el-input-number v-model="configuration.askHighOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit()">确认修改</el-button>
        </el-form-item>
      </el-form>
      <div class="interval-content">
        <p>
          <span>外部指数价：</span>
          <span>{{ pair ? intervalInfo.indexPrice ? intervalInfo.indexPrice : 'null' : '--' }}</span>
        </p>
        <p>
          <span>当前买指数价：</span>
          <span>{{ pair ? intervalInfo.bidPrice ? intervalInfo.bidPrice : 'null' : '--' }}</span>
        </p>
        <p>
          <span>当前卖指数价：</span>
          <span>{{ pair ? intervalInfo.askPrice ? intervalInfo.askPrice : 'null' : '--' }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import './cache'
import {mapActions, mapState} from "vuex";
import api from "@/entries/Machine/api";

export default {
  name: "MarketQuotations",
  data() {
    return {
      pair:'',
      maxLengthNum:'',
      exchangeSrcEnum:this.exchangeSrcOp1,
      customPrice:{},
      configuration: {
        machineType:'',
        config:'',
        otherConfig:''
      },
      rules: {
        thresholdStopProcessDepth: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        dealAmtPercentage: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        bidBaseAmt: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        askBaseAmt: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        bidPriceDensity: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        askPriceDensity: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        bidFirstPlaceDiscounted: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        askFirstPlaceDiscounted: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        interval: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        userId: [{required: true, message: '用户Id不能为空', trigger: 'blur'}],
        machineType: [{required: true, message: '类型不能为空', trigger: 'blur'}],
        pair: [{required: true, message: '交易对不能为空', trigger: 'blur'}],
        askPositionAmount: [{required: true, message: '数量不能为空', trigger: 'blur'}],
        bidPositionAmount: [{required: true, message: '数量不能为空', trigger: 'blur'}],
        bidPositionReduce: [{required: true, message: '数量不能为空', trigger: 'blur'}],
        askPositionReduce: [{required: true, message: '数量不能为空', trigger: 'blur'}],
        bidTradePriceRate: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        askTradePriceRate: [{required: true, message: '数据不能为空', trigger: 'blur'}],
      },
      intervalInfo: {},
      timer: null
    }
  },
  computed: {
    ...mapState('quotationCache', ['configurations', 'machineTypeOptions', 'customPosition',
      'exchangeSrcOp1', 'exchangeSrcOp2', 'exchangeSrcOp3']),
  },
  methods:{
    ...mapActions('quotationCache', ['queryConfigurations', 'updateConfiguration']),

    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },

    createStateFilter(queryString) {
      return (state) => {
        return (state.pair.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    querySearchAsync(queryString, cb) {
      let restaurants = this.configurations;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].pair});
      }
      cb(suggest);
    },

    findOne() {
      let len = this.configurations.length;
      this.configuration = {};
      for (let i = 0; i < len; i++) {
        if (this.pair === this.configurations[i].pair) {
          this.configuration = this.deepCopy(this.configurations[i]);
          return;
        }
      }
    },

    buildParamsBeforeRequest(formData){
      for (let key in formData){
        if (this.customPosition.hasOwnProperty(key)){
          let lower = key + "Lower";
          let upper = key + "Upper";
          if (parseFloat(formData[lower]) > parseFloat(formData[upper])){
            let msg = this.customPosition[key] + ',参数错误，区间最小值大于区间最大值';
            this.$message.error(msg)
            formData.validate = false
            return formData;
          }
          formData[key] = formData[lower] + "," + formData[upper]
        }
      }
      return formData
    },

    refreshConfigurations(){
      this.queryConfigurations();
    },

    submit() {
      this.configuration.validate = ''
      if (this.configuration.pair === undefined){
        this.$message.error('请选择交易对')
        return;
      }
      if (this.configuration['srcExchanges'] !== 'UNISWAP'
          && this.configuration['srcExchanges'] !== 'MDEX'
          && this.configuration['srcExchanges'] !== 'FIXED_USDT'
          && this.configuration['srcExchanges'] !== 'CUSTOM_PRICE'
          && this.configuration['srcExchanges'] !== 'PANCAKE'
          && this.configuration['srcExchanges'] !== 'BAKERY'
          && this.configuration['srcExchanges'] !== 'PANGOLIN'
          && this.configuration['srcExchanges'] !== 'SPOOKYSWAP'
          && this.configuration['srcExchanges'] !== 'SHIBASWAP'
          && this.configuration['srcExchanges'] !== 'JOE'
          && this.configuration['srcExchanges'] !== 'SUSHI'
          && this.configuration['srcExchanges'] !== 'RAYDIUM'
          && this.configuration['srcExchanges'] !== 'QUICKSWAP'
      ){
        //this.configuration['otherConfig'] = ''
      }
      if(this.configuration.priceManualDeviateFlag === '1'){
        if (this.configuration.priceManualDeviateRatio === ''){
          this.$message.error('请输入指数价手动偏移比例')
          return
        }
      }
      if (this.configuration.priceAutoDeviateFlag === '1'){
        if (this.configuration.priceAutoDeviateAmt === ''){
          this.$message.error('请输入指数价自动偏移量')
          return
        }
        if (this.configuration.priceAutoDeviateRatio === ''){
          this.$message.error('请输入指数价自动偏移比例')
          return
        }
        if (this.configuration.priceAutoDeviateMaxRate === ''){
          this.$message.error('请输入动态回撤最大比例')
          return
        }
      }
      this.configuration = this.buildParamsBeforeRequest(this.configuration)
      if (this.configuration.validate === false) { return }
      if (this.configuration.srcExchanges==='CUSTOM_PRICE' && this.customPrice[this.pair] !== undefined){
        let currentCustomPrice = parseFloat(this.configuration.otherConfig)
        let latestCustomPrice = this.customPrice[this.pair]
        if (currentCustomPrice > latestCustomPrice * 1.2 || currentCustomPrice < latestCustomPrice * 0.8) {
          let msg = "当前指数价：" + currentCustomPrice + "，上次指数价：" + latestCustomPrice + "，波动已超过20%，是否继续？"
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.updateConfiguration(this.configuration).then( ()=> {
              this.$message({type : "success",message : "修改成功"})
              if (this.configuration.srcExchanges==='CUSTOM_PRICE'){
                this.customPrice[this.pair] = parseFloat(this.configuration.otherConfig)
              }
              this.queryConfigurations();
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
          return;
        }
      }
      this.updateConfiguration(this.configuration).then( ()=> {
        this.$message({type : "success",message : "修改成功"})
        if (this.configuration.srcExchanges === 'CUSTOM_PRICE'){
          this.customPrice[this.pair] = parseFloat(this.configuration.otherConfig)
        }
        this.queryConfigurations();
      });
    },

    exportExcelMarket() {
      const columns = [{title:'币对', key:'pair'},{title:'用户id', key:'userId'},
        {title:'类型', key:'syncQuotationType'},{title:'交易所', key:'srcExchanges'},
        {title:'UNISWAP TOKEN ID', key:'otherConfig'},{title:'价差比例阈值', key:'thresholdStopProcessDepth'},
        {title:'成交量缩放', key:'dealAmtPercentage'},{title:'买baseAmt', key:'bidBaseAmt'},
        {title:'卖baseAmt', key:'askBaseAmt'}, {title:'买密度', key:'bidPriceDensity'},{title:'卖密度', key:'askPriceDensity'},
        {title:'买1撤回', key:'bidFirstPlaceDiscounted'},  {title:'卖1撤回', key:'askFirstPlaceDiscounted'},
        {title:'买方向委托量缩小档位', key:'bidPositionReduce'},{title:'卖方向委托量缩小档位', key:'askPositionReduce'},
        {title:'买方向档位固定金额', key:'bidPositionAmount'},{title:'卖方向档位固定金额', key:'askPositionAmount'},
        {title:'买吃单价差', key:'bidTradePriceRate'},{title:'卖吃单价差', key:'askTradePriceRate'},
        {title:'时间间隔（秒）', key:'interval'},{title:'等级', key:'level'},
        {title:'指数价手动偏移开关', key:'priceManualDeviateFlag'}, {title:'指数价手动偏移比例', key:'priceManualDeviateRatio'},
      ]
      const obj = {"pair":"pair","userId":"userId","syncQuotationType":"syncQuotationType","srcExchanges":"srcExchanges","otherConfig":"otherConfig",
        "thresholdStopProcessDepth":"thresholdStopProcessDepth","dealAmtPercentage":"dealAmtPercentage",
        "bidBaseAmt":"bidBaseAmt","askBaseAmt":"askBaseAmt","bidPriceDensity":"bidPriceDensity","askPriceDensity":"askPriceDensity",
        "bidFirstPlaceDiscounted":"bidFirstPlaceDiscounted","askFirstPlaceDiscounted":"askFirstPlaceDiscounted","bidPositionReduce":"bidPositionReduce",
        "askPositionReduce":"askPositionReduce","bidPositionAmount":"bidPositionAmount","askPositionAmount":"askPositionAmount",
        "bidTradePriceRate":"bidTradePriceRate","askTradePriceRate":"askTradePriceRate",
        "level":"level","interval":"interval","priceManualDeviateFlag":"priceManualDeviateFlag","priceManualDeviateRatio":"priceManualDeviateRatio"}
      const list = this.configurations.filter((item)=>{ return item;})
      list.unshift(obj);
      api.export2Excel("行情",columns, list);
    },
    // 获取指数价
    getIndexPrice() {
      api.getPrice({pair: this.pair}).then(res => {
        if (res.code !== 0) {
          this.clearTimer()
        } else {
          this.intervalInfo = res.data
        }
      }).catch( e=> {
        this.clearTimer()
      })
    },
    setTimer() {
      this.clearTimer()
      this.timer = setInterval(() => {
        this.getIndexPrice()
      }, 30 * 1000)
    },
    clearTimer() {
      clearInterval(this.timer)
      this.timer = null
    }
  },

  watch:{
    'configuration.machineType'(val){
      if(val === "AUTO_RISK_HEDGE"){
        this.exchangeSrcEnum = this.exchangeSrcOp1
      } else if (val === "SYNC_INDEX_PRICE"){
        this.exchangeSrcEnum = this.exchangeSrcOp3
      }else{
        this.exchangeSrcEnum = this.exchangeSrcOp2
      }
    },
    'maxLengthNum'(val){
      let inputLength = this.configuration.otherConfig.length
      if (inputLength > val){
        try {
          this.configuration.otherConfig = ''
        } catch (e){}
      }
    },
    pair(val) {
      if (val && this.configurations.findIndex(item => item.pair === val) !== -1)  {
        this.getIndexPrice()
        this.setTimer()
      } else {
        this.clearTimer()
      }
    }
  },
}
</script>

<style scoped>
.block{
  background-color: white;
  margin: 10px 15px 10px 15px;
  padding: 40px 30px 10px 30px;
  height: auto;
  position: relative;
}
.block .interval-content {
  position: absolute;
  top: 102px;
  right: 100px;
}
.block .interval-content p {
  height: 40px;
  line-height: 40px;
  margin: 0 0 22px 0;
}
.block .interval-content p span {
  float: left;
  padding-right: 20px;
  min-width: 104px;
}
.block .interval-content p span:nth-last-child(1) {
  text-align: right;
  padding-right: 0;
}
</style>